/**
 * Internal dependencies
 */
import {
    CURRENT_VISUALDECK_RECEIVE,
    CURRENT_VISUALDECK_REQUEST,
    CURRENT_VISUALDECK_REQUEST_SUCCESS,
    CURRENT_VISUALDECK_REQUEST_FAILURE,
} from 'state/action-types';

import cscom from 'lib/customer-site-api';
import {getCurrentVisualDeck, requestingCurrentVisualDeck} from 'state/current-visual-deck/selectors';

/**
 * [description]
 *
 * @param  {[type]} visualdeck [description]
 * @return {[type]}         [description]
 */
export const setCurrentVisualDeck = (visualdeck) => {
    return {
        type: CURRENT_VISUALDECK_RECEIVE,
    };
};

/**
 * [description]
 *
 * @param  {[type]} ) [description]
 * @return {[type]}   [description]
 */
export const requestCurrentVisualDeck = () => (dispatch) => {
    dispatch({
        type: CURRENT_VISUALDECK_REQUEST,
    });

    return cscom
        .currentVisualDeck()
        .list()
        .then((visualdeck) => {
            dispatch({
                type: CURRENT_VISUALDECK_REQUEST_SUCCESS,
            });
            dispatch({
                type: CURRENT_VISUALDECK_RECEIVE,
                payload: {
                    visualdeck,
                },
            });
            return visualdeck;
        })
        .catch((error) => {
            if (error == 'Error: Not Found') {
                dispatch({
                    type: CURRENT_VISUALDECK_REQUEST_SUCCESS,
                });
                return;
            }
            dispatch({
                type: CURRENT_VISUALDECK_REQUEST_FAILURE,
                error,
            });
        });
};

/**
 * [description]
 * 
 * @param  {...[type]} props) [description]
 * @return {[type]}           [description]
 */
export const requestCurrentVisualDeckIfNotRequested = (...props) => async (dispatch, getState) => {
    const currentVisualDeck = getCurrentVisualDeck(getState());
    const requesting = requestingCurrentVisualDeck(getState());

    //if (!currentVisualDeck && requesting == false) {
        return dispatch(requestCurrentVisualDeck(...props))
    //}

    return currentVisualDeck;
}
